import React from 'react';
import { Dashboard } from 'components/Dashboard';
import { Request } from 'components/Request';
import { StreamsComponent } from 'react/stream/StreamsComponent';
import { StreamComponent } from './StreamComponent';

export default class FeaturedStreamsComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			maximized: false
		};
		this.updateToggle = this.updateToggle.bind(this);
	}

	componentDidMount() {
		Dashboard.startupEvents.then(() => {
			if(this.unmounted) {
				return;
			}
			this.setState({
				maximized: !!myUser.containers.featured_streams
			});
		});
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	updateToggle() {
		const maximized = !this.state.maximized;
		this.setState({
			maximized: !!maximized
		});
		Request.apiv1('matchmaking/toggle_displayed_list', {
			list_name: 'featured_streams_maximized',
			is_visible: maximized
		});
	}

	render() {
		const { maximized } = this.state;
		const { streams } = this.props;
		return null;
		return (
			<div className={`stream_container hidden-xs ${maximized ? 'maximized' : ''}`}>
				<h3
					className='heading'>
					<span onClick={this.updateToggle} className='text'>
						{maximized && <i className='fa fa-caret-down' />}
						{!maximized && <i className='fa fa-caret-right' />}
						{' '}
						Featured Streams
					</span>
					{!maximized && streams.length > 0 &&
					<span className='count badge'>{streams.length}</span>
					}
				</h3>

				{maximized && streams.length === 0 &&
				<div className='no_streams'>
					<span>
						No Streams Currently Featured! Connect Your Stream to Your Profile and Start Playing!
					</span>
				</div>
				}
				{maximized && streams.length > 0 &&
				<div className='active_streams'>
					{streams.map((stream) => (
						<StreamComponent
							matchStyle
							key={stream.id ? stream.id : stream.channel_name}
							stream={stream}
						/>
					))}
				</div>
				}
			</div>
		);
	}
}